import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const CompanyFilter: any = (
  props: any
) => {
  const { company, handleCompanyChange, isCompanyEnabled, companyError } = props
  useEffect(() => {
    if (!isCompanyEnabled) {
      handleCompanyChange({ target: { value: "", name: "company" } } as any, "company");
    }
  }, [isCompanyEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          company: company,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="company"
            placeholder="Enter Company"
            optional={false}
            disabled={false}
            value={company}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleCompanyChange(e, "company")
            }
          />
          {companyError && <div className="error-text">{companyError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default CompanyFilter;